//Polyfill observer api scripts
import 'intersection-observer';
import { install } from 'resize-observer';
if (!window.ResizeObserver) install();